function Slogun() {
  return (
    <div className='px-5 py-14 lg:pt-40 md:pb-24 text-center lg:flex lg:flex-col lg:justify-center lg:items-center text-white bg-[url("/public/assets/images/home/bg_slogun.jpg")] bg-cover bg-center'>
      <p
        className='text-2xl font-bold md:text-[2.8rem] md:leading-[2.9rem] fade-01'
        data-aos='fade-up'
      >
        젊은 생각, 앞선 걸음으로
        <br className='md:hidden' /> 만드는 새로운 미래
      </p>
      <p
        className='mt-3 text-base font-medium md:text-xl md:mt-10 md:leading-9 fade-02'
        data-aos='fade-up'
        data-aos-duration='1000'
      >
        인간존중, 생명존중을 최우선으로
        <br className='md:hidden' /> 하는 노아에서는{' '}
        <span className='md:block'>
          앞으로 전략을 추진하여
          <br className='md:hidden' /> 새로운 프로젝트를 완성해 나가겠습니다.
        </span>
      </p>
      <a
        href='/contact'
        className='md:mt-8 mt-4 inline-block text-sm font-bold md:font-semibold text-[#274274] bg-white rounded-full py-4 px-8 md:py-5 md:px-20 md:text-black md:text-xl'
      >
        문의하기
      </a>
    </div>
  );
}

export default Slogun;
